export default "__VITE_ASSET__6xIgcv0x__"